"use client";

import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";
import { useLang } from "@/providers/langProvider";
import Script from "next/script";
import { useEffect, useState } from "react";

type TProps = { price: number };

const TamaraPromo: React.FC<TProps> = ({ price }) => {
  const { data } = useGetCompanyQuery();
  const convert = data?.result?.theme?.settings?.enable_currencies_converter;
  const { currency, convertToCurrentCurrency } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });
  const [ready, setReady] = useState(false);
  const lang = useLang();
  useEffect(() => {
    if (ready) {
      if ((window as any).TamaraProductWidget) {
        (window as any).TamaraProductWidget.init({
          lang: "",
          currency: "",
          publicKey: "",
        });
        (window as any).TamaraProductWidget.render();
      }
    }
  }, [ready, lang, price, currency.code]);
  return (
    <div style={{ maxWidth: 720 }}>
      <div
        className="tamara-product-widget"
        data-lang={lang}
        data-price={convert ? convertToCurrentCurrency(price) : price}
        data-currency={currency?.code}
        data-payment-type="installment"
        data-disable-installment="false"
        data-disable-paylater="false"
      />
      <Script
        src="https://cdn.tamara.co/widget/product-widget.min.js"
        onReady={() => {
          setReady(true);
        }}
      />
    </div>
  );
};

export default TamaraPromo;
